// templateData.js

export const initialTopics = [
  {
    id: 1,
    title: 'Abdominal Pain'
  },
  {
    id: 2,
    title: 'Annual H&P'
  },
  {
    id: 3,
    title: 'Chest Pain'
  },
  {
    id: 4,
    title: 'Headache'
  },
  {
    id: 5,
    title: 'Knee Pain'
  },
  {
    id: 6,
    title: 'Nausea & Vomiting'
  },
  {
    id: 7,
    title: 'URI'
  },
  {
    id: 8,
    title: 'UTI'
  },
  {
    id: 9,
    title: 'Venous Insufficiency'
  },
  {
    id: 10,
    title: 'Back Pain'
  },
  {
    id: 11,
    title: 'Neck Pain'
  },
  {
    id: 12,
    title: 'Shoulder Pain'
  },
  {
    id: 13,
    title: 'Dizziness'
  },
  {
    id: 14,
    title: 'Fatigue'
  },
  {
    id: 15,
    title: 'Fever'
  },
  {
    id: 16,
    title: 'Cough'
  },
  {
    id: 17,
    title: 'Shortness of Breath'
  },
  {
    id: 18,
    title: 'Palpitations'
  },
  {
    id: 19,
    title: 'Constipation'
  },
  {
    id: 20,
    title: 'Diarrhea'
  },
  {
    id: 21,
    title: 'GERD'
  },
  {
    id: 22,
    title: 'Joint Pain'
  },
  {
    id: 23,
    title: 'Muscle Pain'
  },
  {
    id: 24,
    title: 'Skin Rash'
  },
  {
    id: 25,
    title: 'Insomnia'
  }
];

export const initialTemplateText = {
  1: [
    {
      id: 1,
      text:
        'Patient has associated nausea, vomiting with the abdominal pain.',
      checked: false
    },
    {
      id: 2,
      text:
        'Patient denied hematochezia or melena.',
      checked: false
    },
    {
      id: 3,
      text:
        'Patient denied recent traveling or eating out in a restaurant.',
      checked: false
    },
    {
      id: 4,
      text:
        'Patient reports intermittent abdominal discomfort.',
      checked: false
    },
    {
      id: 5,
      text:
        'Patient reports worsening abdominal pain after meals.',
      checked: false
    },
    {
      id: 6,
      text:
        'Patient denies fever or chills.',
      checked: false
    },
    {
      id: 7,
      text:
        'Patient denies any recent change in bowel habits.',
      checked: false
    },
    {
      id: 8,
      text:
        'Patient reports decreased appetite.',
      checked: false
    },
    {
      id: 9,
      text:
        'Patient denies urinary symptoms.',
      checked: false
    },
    {
      id: 10,
      text:
        'Patient reports abdominal bloating and discomfort.',
      checked: false
    },
    {
      id: 11,
      text:
        'Patient denies previous abdominal surgery.',
      checked: false
    },
    {
      id: 12,
      text:
        'Patient reports symptoms started several days ago.',
      checked: false
    },
    {
      id: 13,
      text:
        'Patient reports pain is intermittent in nature.',
      checked: false
    },
    {
      id: 14,
      text:
        'Patient reports no significant improvement with rest.',
      checked: false
    },
    {
      id: 15,
      text:
        'Patient denies blood in the stool.',
      checked: false
    }
  ],

  2: [
    {
      id: 1,
      text:
        'Patient presents today for annual health maintenance examination.',
      checked: false
    },
    {
      id: 2,
      text:
        'Patient reports no new health concerns.',
      checked: false
    },
    {
      id: 3,
      text:
        'Preventive health recommendations were reviewed.',
      checked: false
    }
  ],

  3: [
    {
      id: 1,
      text:
        'Patient reports intermittent chest discomfort.',
      checked: false
    },
    {
      id: 2,
      text:
        'Patient denies shortness of breath.',
      checked: false
    },
    {
      id: 3,
      text:
        'Patient denies dizziness or syncope.',
      checked: false
    },
    {
      id: 4,
      text:
        'Patient denies radiation of pain to the arm or jaw.',
      checked: false
    }
  ],

  5: [
    {
      id: 1,
      text:
        'Patient reports knee pain with activity.',
      checked: false
    },
    {
      id: 2,
      text:
        'Patient denies recent trauma or injury.',
      checked: false
    },
    {
      id: 3,
      text:
        'Patient reports stiffness after prolonged sitting.',
      checked: false
    }
  ],

  6: [
    {
      id: 1,
      text:
        'Patient reports nausea with occasional vomiting.',
      checked: false
    },
    {
      id: 2,
      text:
        'Patient reports decreased appetite.',
      checked: false
    },
    {
      id: 3,
      text:
        'Patient denies hematemesis.',
      checked: false
    }
  ],

  7: [
    {
      id: 1,
      text:
        'Patient reports nasal congestion and sore throat.',
      checked: false
    },
    {
      id: 2,
      text:
        'Patient reports dry cough.',
      checked: false
    },
    {
      id: 3,
      text:
        'Patient denies shortness of breath.',
      checked: false
    }
  ],

  8: [
    {
      id: 1,
      text:
        'Patient reports increased urinary frequency.',
      checked: false
    },
    {
      id: 2,
      text:
        'Patient reports burning sensation with urination.',
      checked: false
    },
    {
      id: 3,
      text:
        'Patient denies flank pain.',
      checked: false
    }
  ]
};